/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {GlavnaKnjigaModel} from '../../models/GlavnaKnjigaModel'
import {fetchGlavnaKnjiga, saveGlavnaKnjiga, updateGlavnaKnjiga} from '../../api/glavnaKnjigaProizvodnje'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import notifyToast from '../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import TitleComponent from '../../components/TitleComponent/TitleComponent'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import clsx from 'clsx'
import PanelTipDropdown from './components/PanelTipDropdown/PanelTipDropdown'
import SmjenePanelaDropdown from './components/SmjenePanelaDropdown/SmjenePanelaDropdown'
import PanelIzolacijaDropdown from './components/PanelIzolacijaDropdown/PanelIzolacijaDropdown'
import {KTIcon} from '../../../_websoft/helpers'

const GlavnaKnjigaDetails = () => {
    const {id} = useParams()
    const IdFromURL = Number(id)

    const [loading, setLoading] = useState(true)

    const initialValues = {
        tipPanela: undefined,
        izolacija: undefined,
        brojNaloga: [],
        godina: [],
        stavkaNaloga: [],
        dioNaloga: [1],
        nalogZavrsen: [],
        skart: undefined,
        skartLimova: undefined,
        skartVrstaLima: undefined,
        skartRavniLimova: undefined,
        skartTrapeza: undefined,
        brojStiklanja: undefined,
        ravniLimOdmotanPrijePro: undefined,
        proizvedeno: undefined,
        smjena: undefined,
        izmjenaAlata: 0,
        zastoj: 0,
        sati: undefined,
        minute: undefined,
        komentarZastoja: undefined,
        komentar: undefined,
    }

    const [initialData, setInitialData] = useState<Partial<GlavnaKnjigaModel>>(initialValues)

    const navigate = useNavigate()

    useEffect(() => {
        if (IdFromURL) {
            fetchGlavnaKnjiga(IdFromURL)
                .then((data) => {
                    setInitialData(data)
                    formik.resetForm({values: data}) // keep as-is
                })
                .catch((error) => notifyToast(false, error.response.data.message))
                .finally(() => setLoading(false))
        } else {
            setLoading(false)
        }
    }, [IdFromURL])

    const validationSchema = Yup.object({
        tipPanela: Yup.number().required('required'),
        izolacija: Yup.number().required('izolacija'),
        proizvedeno: Yup.number().required('required'),
        smjena: Yup.string().required('required'),
    })

    const formik = useFormik({
        initialValues: initialData,
        validationSchema: validationSchema,
        onSubmit: async (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            try {
                let response
                if (IdFromURL) {
                    response = await updateGlavnaKnjiga(IdFromURL, values)
                    setTimeout(() => {
                        navigate(-1)
                    }, 3000)
                } else {
                    response = await saveGlavnaKnjiga(values)
                    setTimeout(() => {
                        navigate(-1)
                    }, 3000)
                }

                if (response.error === 0) {
                    notifyToast(true, response.message)
                } else {
                    notifyToast(false, response.message || 'An unexpected error occurred.')
                }
            } catch (error: any) {
                console.error('Error: ', error)
                notifyToast(false, error.response.data.message)
                setStatus(error)
            } finally {
                setLoading(false)
                setSubmitting(false)
            }
        },
    })

    return (
        <div className='container-xxl px-0'>
            <ToastContainer />

            <div className='card mb-5 mb-xl-10 shadow-sm'>
                {/* Header */}
                <div
                    className='card-header border-0 cursor-pointer py-4'
                    role='button'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0 w-100'>
                        <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 w-100'>
                            <div className='d-flex align-items-center gap-3 flex-wrap'>
                                <TitleComponent name='Glavna Knjiga' />
                                <span className='badge bg-light text-dark border'>
                  {IdFromURL ? (
                      <>
                          <KTIcon iconName='pencil' className='fs-6 me-2' />
                          Uređivanje
                      </>
                  ) : (
                      <>
                          <KTIcon iconName='plus' className='fs-6 me-2' />
                          Novi unos
                      </>
                  )}
                </span>
                            </div>

                            <div className='text-muted'>
                                Popunite obavezna polja označena sa <span className='text-danger fw-bold'>*</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div id='kt_account_profile_details' className='collapse show'>
                    {loading ? (
                        <div className='p-6'>
                            <LoadingComponent />
                        </div>
                    ) : (
                        <form onSubmit={formik.handleSubmit} noValidate>
                            <div className='card-body border-top p-4 p-md-6'>
                                {/* SECTION: Osnovno */}
                                <div className='card bg-light border-0 mb-6'>
                                    <div className='card-body p-4 p-md-5'>
                                        <div className='d-flex align-items-center justify-content-between mb-4'>
                                            <div>
                                                <div className='fw-bolder text-dark fs-4'>Osnovni podaci</div>
                                                <div className='text-muted'>Tip panela, izolacija i osnovni parametri proizvodnje</div>
                                            </div>
                                            <span className='badge bg-primary'>Obavezno</span>
                                        </div>

                                        <div className='row g-4'>
                                            {/* Tip Panela */}
                                            <div className='col-12 col-lg-6'>
                                                <label className='form-label fw-bold'>
                                                    <span className='required'>Tip Panela</span>
                                                </label>
                                                <div className='fv-row'>
                                                    <PanelTipDropdown
                                                        value={formik.values.tipPanela}
                                                        onChange={(name, value) => formik.setFieldValue('tipPanela', value)}
                                                        errors={formik.errors.tipPanela}
                                                        touched={formik.touched.tipPanela}
                                                        selectName='tipPanela'
                                                    />
                                                </div>
                                            </div>

                                            {/* Izolacija */}
                                            <div className='col-12 col-lg-6'>
                                                <label className='form-label fw-bold'>
                                                    <span className='required'>Izolacija</span>
                                                </label>
                                                <div className='fv-row'>
                                                    <PanelIzolacijaDropdown
                                                        value={formik.values.izolacija}
                                                        onChange={(name, value) => formik.setFieldValue('izolacija', value)}
                                                        errors={formik.errors.izolacija}
                                                        touched={formik.touched.izolacija}
                                                        selectName='izolacija'
                                                    />
                                                </div>
                                            </div>

                                            {/* Proizvedeno */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label required fw-bold'>Proizvedeno (m²)</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='Unesite proizvedenu količinu'
                                                        {...formik.getFieldProps('proizvedeno')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': formik.touched.proizvedeno && formik.errors.proizvedeno},
                                                            {'is-valid': formik.touched.proizvedeno && !formik.errors.proizvedeno}
                                                        )}
                                                    />
                                                    {formik.touched.proizvedeno && formik.errors.proizvedeno && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.proizvedeno}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Smjena */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>
                                                    <span className='required'>Smjena</span>
                                                </label>
                                                <div className='fv-row'>
                                                    <SmjenePanelaDropdown
                                                        value={formik.values.smjena}
                                                        onChange={(name, value) => formik.setFieldValue('smjena', value)}
                                                        errors={formik.errors.smjena}
                                                        touched={formik.touched.smjena}
                                                        selectName='smjena'
                                                    />
                                                </div>
                                            </div>

                                            {/* Izmjena alata */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Izmjena alata</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('izmjenaAlata')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': formik.touched.izmjenaAlata && formik.errors.izmjenaAlata},
                                                            {'is-valid': formik.touched.izmjenaAlata && !formik.errors.izmjenaAlata}
                                                        )}
                                                    />
                                                    {formik.touched.izmjenaAlata && formik.errors.izmjenaAlata && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.izmjenaAlata}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* SECTION: Zastoj */}
                                <div className='card border mb-6'>
                                    <div className='card-body p-4 p-md-5'>
                                        <div className='d-flex align-items-center justify-content-between mb-4'>
                                            <div>
                                                <div className='fw-bolder text-dark fs-4'>Zastoj</div>
                                                <div className='text-muted'>Evidencija zastoja i trajanja</div>
                                            </div>
                                            <span className='badge bg-light text-dark border'>Opcionalno</span>
                                        </div>

                                        <div className='row g-4'>
                                            {/* Zastoj */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Zastoj</label>
                                                <div className='fv-row'>
                                                    <select
                                                        {...formik.getFieldProps('zastoj')}
                                                        className={clsx(
                                                            'form-select form-select-lg form-select-solid',
                                                            {'is-invalid': formik.touched.zastoj && formik.errors.zastoj},
                                                            {'is-valid': formik.touched.zastoj && !formik.errors.zastoj}
                                                        )}
                                                    >
                                                        <option value=''>Odaberi...</option>
                                                        <option
                                                            value='0'
                                                            onClick={() => {
                                                                formik.setFieldValue('sati', undefined)
                                                                formik.setFieldValue('minute', undefined)
                                                            }}
                                                        >
                                                            Ne
                                                        </option>
                                                        <option value='1'>Da</option>
                                                    </select>

                                                    {formik.touched.zastoj && formik.errors.zastoj && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.zastoj}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Trajanje zastoja (conditional) */}
                                            {formik.values.zastoj && formik.values.zastoj.toString() === '1' && (
                                                <div className='col-12 col-md-6 col-lg-8'>
                                                    <label className='form-label fw-bold'>Trajanje zastoja</label>

                                                    <div className='row g-3'>
                                                        <div className='col-12 col-sm-6'>
                                                            <div className='input-group input-group-lg input-group-solid'>
                                                                <span className='input-group-text'>Sati</span>
                                                                <input
                                                                    type='text'
                                                                    placeholder='0'
                                                                    {...formik.getFieldProps('sati')}
                                                                    className={clsx(
                                                                        'form-control form-control-lg form-control-solid',
                                                                        {'is-invalid': formik.touched.sati && formik.errors.sati},
                                                                        {'is-valid': formik.touched.sati && !formik.errors.sati}
                                                                    )}
                                                                />
                                                            </div>
                                                            {formik.touched.sati && formik.errors.sati && (
                                                                <div className='fv-plugins-message-container'>
                                                                    <div className='fv-help-block'>{formik.errors.sati}</div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className='col-12 col-sm-6'>
                                                            <div className='input-group input-group-lg input-group-solid'>
                                                                <span className='input-group-text'>Minute</span>
                                                                <input
                                                                    type='text'
                                                                    placeholder='0'
                                                                    {...formik.getFieldProps('minute')}
                                                                    className={clsx(
                                                                        'form-control form-control-lg form-control-solid',
                                                                        // keep your existing touched/errors keys exactly
                                                                        {'is-invalid': (formik.touched as any).minute && (formik.errors as any).minute},
                                                                        {'is-valid': (formik.touched as any).minute && !(formik.errors as any).minute}
                                                                    )}
                                                                />
                                                            </div>

                                                            {(formik.touched as any).minute && (formik.errors as any).minute && (
                                                                <div className='fv-plugins-message-container'>
                                                                    <div className='fv-help-block'>{(formik.errors as any).minute}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='form-text mt-2'>
                                                        Unesite trajanje samo ako je zastoj = <span className='fw-semibold'>Da</span>.
                                                    </div>
                                                </div>
                                            )}

                                            {/* Komentar zastoja */}
                                            <div className='col-12'>
                                                <label className='form-label fw-bold'>Komentar zastoja</label>
                                                <div className='fv-row'>
                          <textarea
                              placeholder='Opišite razlog zastoja (ako postoji)'
                              rows={3}
                              {...formik.getFieldProps('komentarZastoja')}
                              className={clsx(
                                  'form-control form-control-lg form-control-solid',
                                  {'is-invalid': formik.touched.komentarZastoja && formik.errors.komentarZastoja},
                                  {'is-valid': formik.touched.komentarZastoja && !formik.errors.komentarZastoja}
                              )}
                          />
                                                    {formik.touched.komentarZastoja && formik.errors.komentarZastoja && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.komentarZastoja}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* SECTION: Dodatno */}
                                <div className='card border mb-6'>
                                    <div className='card-body p-4 p-md-5'>
                                        <div className='d-flex align-items-center justify-content-between mb-4'>
                                            <div>
                                                <div className='fw-bolder text-dark fs-4'>Dodatni podaci</div>
                                                <div className='text-muted'>Štiklanje, lim i opšti komentar</div>
                                            </div>
                                            <span className='badge bg-light text-dark border'>Opcionalno</span>
                                        </div>

                                        <div className='row g-4'>
                                            {/* brojStiklanja */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Broj štiklanja</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('brojStiklanja')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': formik.touched.brojStiklanja && formik.errors.brojStiklanja},
                                                            {'is-valid': formik.touched.brojStiklanja && !formik.errors.brojStiklanja}
                                                        )}
                                                    />
                                                    {formik.touched.brojStiklanja && formik.errors.brojStiklanja && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.brojStiklanja}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* ravniLimOdmotanPrijePro */}
                                            <div className='col-12 col-lg-8'>
                                                <label className='form-label fw-bold'>Ravni lim odmotan prije starta proizvodnje</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('ravniLimOdmotanPrijePro')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {
                                                                'is-invalid':
                                                                    formik.touched.ravniLimOdmotanPrijePro && formik.errors.ravniLimOdmotanPrijePro,
                                                            },
                                                            {
                                                                'is-valid':
                                                                    formik.touched.ravniLimOdmotanPrijePro && !formik.errors.ravniLimOdmotanPrijePro,
                                                            }
                                                        )}
                                                    />
                                                    {formik.touched.ravniLimOdmotanPrijePro && formik.errors.ravniLimOdmotanPrijePro && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.ravniLimOdmotanPrijePro}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* komentar */}
                                            <div className='col-12'>
                                                <label className='form-label fw-bold'>Komentar</label>
                                                <div className='fv-row'>
                          <textarea
                              placeholder='Dodatna napomena (opcionalno)'
                              rows={4}
                              {...formik.getFieldProps('komentar')}
                              className={clsx(
                                  'form-control form-control-lg form-control-solid',
                                  {'is-invalid': formik.touched.komentar && formik.errors.komentar},
                                  {'is-valid': formik.touched.komentar && !formik.errors.komentar}
                              )}
                          />
                                                    {formik.touched.komentar && formik.errors.komentar && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.komentar}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* SECTION: Kontrolori */}
                                <div className='card border border-warning mb-0'>
                                    <div className='card-body p-4 p-md-5'>
                                        <div className='d-flex align-items-start justify-content-between gap-3 mb-4'>
                                            <div>
                                                <div className='fw-bolder text-dark fs-4'>Kontrola kvaliteta</div>
                                                <div className='text-muted'>Podatke ispod upisuju kontrolori</div>
                                            </div>
                                            <span className='badge bg-warning text-dark'>Kontrolori</span>
                                        </div>

                                        <div className='alert alert-warning d-flex align-items-start gap-3 mb-5'>
                                            <i className='fas fa-exclamation-triangle fs-4 mt-1' />
                                            <div>
                                                <div className='fw-bolder'>Napomena</div>
                                                <div className='mb-0'>Ovaj dio popunjavaju uposlenici kontrole kvaliteta.</div>
                                            </div>
                                        </div>

                                        <div className='row g-4'>
                                            {/* skart */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Škart panela</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('skart')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': formik.touched.skart && formik.errors.skart},
                                                            {'is-valid': formik.touched.skart && !formik.errors.skart}
                                                        )}
                                                    />
                                                    {formik.touched.skart && formik.errors.skart && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.skart}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* skartRavniLimova */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Škart ravnog lima</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('skartRavniLimova')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': (formik.touched as any).skartLimova && (formik.errors as any).skartRavniLimova},
                                                            {'is-valid': formik.touched.skartRavniLimova && !formik.errors.skartRavniLimova}
                                                        )}
                                                    />
                                                    {formik.touched.skartRavniLimova && formik.errors.skartRavniLimova && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.skartRavniLimova}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* skartTrapeza */}
                                            <div className='col-12 col-md-6 col-lg-4'>
                                                <label className='form-label fw-bold'>Škart trapeza</label>
                                                <div className='fv-row'>
                                                    <input
                                                        type='number'
                                                        placeholder='0'
                                                        {...formik.getFieldProps('skartTrapeza')}
                                                        className={clsx(
                                                            'form-control form-control-lg form-control-solid',
                                                            {'is-invalid': formik.touched.skartTrapeza && formik.errors.skartTrapeza},
                                                            {'is-valid': formik.touched.skartTrapeza && !formik.errors.skartTrapeza}
                                                        )}
                                                    />
                                                    {formik.touched.skartTrapeza && formik.errors.skartTrapeza && (
                                                        <div className='fv-plugins-message-container'>
                                                            <div className='fv-help-block'>{formik.errors.skartTrapeza}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Footer actions */}
                                        <div className='d-flex flex-column flex-sm-row justify-content-end gap-3 mt-6'>
                                            <button
                                                type='button'
                                                className='btn btn-light'
                                                onClick={() => navigate(-1)}
                                                disabled={loading || formik.isSubmitting}
                                            >
                                                Nazad
                                            </button>

                                            <button
                                                type='submit'
                                                className='btn btn-primary px-6'
                                                disabled={loading || formik.isSubmitting || !formik.isValid}
                                            >
                                                {!loading && (
                                                    <>
                                                        <KTIcon iconName='check' className='fs-6 me-2' />
                                                        Potvrdi
                                                    </>
                                                )}
                                                {loading && (
                                                    <span className='indicator-progress d-inline-flex align-items-center'>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2' />
                          </span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Keep original footer if you prefer — but this layout is cleaner */}
                        </form>
                    )}
                </div>
            </div>
        </div>
    )
}

export default GlavnaKnjigaDetails
